import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = ({ metaDataId, simulationDate }: QueryParams) => {
    return network
        .post('api/bo/runSchedulingSimulation', { metaDataId, simulationDate })
        .then((response) => response.data);
};

export const useMutationRunCpmSimulation = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    metaDataId: number;
    simulationDate: number;
}
